import {
  Text,
  Heading,
  Button,
  Flex,
  Box,
  Image,
  Link,
} from "@chakra-ui/react";
import Wrapper from "../../../common/Wrapper";
import { bizflexLogo2, elipse, rectStroke } from "../../../../assets/exports";

const SeventhLayer = () => {
  return (
    <Wrapper>
      <Box
        pos="relative"
        mt="100px"
        pt={{ base: "52px", md: "100px" }}
        bgColor="#0F172B"
        textAlign="center"
        color="#ffff"
        px="20px"
      >
        <Image pos="absolute" right={0} top={0} src={elipse} />
        <Image
          pos="absolute"
          transform="rotate(180deg)"
          bottom={0}
          left={0}
          src={elipse}
        />
        <Text
          pb="6px"
          fontSize={["18px", "24px", "24px", "40px"]}
          fontWeight={500}
        >
          Introducing
        </Text>
        <Heading fontSize={["24px", "24px", "30px", "40px"]}>
          <span style={{ position: "relative", paddingRight: "5px" }}>
            Bizflex Africa:
            <Image
              pos="absolute"
              width={{ base: "70px", md: "auto" }}
              left={0}
              src={rectStroke}
            />
          </span>
          Simplifying School Payments
        </Heading>
        <Text
          pt={{ base: "21px", md: "50px" }}
          color="#B5C2D6"
          maxW="1200px"
          mx="auto"
          fontSize={["14px", "18px", "20px"]}
        >
          BizFlex is a robust financial tool tailored to the needs of
          small-scale businesses and entrepreneurs. It empowers forward-thinking
          leaders with a suite of powerful tools to streamline financial
          operations and drive business growth. With BizFlex, businesses can
          seamlessly legalize their entities with the Corporate Affairs
          Commission in under 5 minutes. Businesses gain instant access to
          corporate accounts, sub-accounts, and a variety of growth-enhancing
          tools, including automated invoicing and receipt systems, virtual
          cards, team management and payroll, bill and airtime purchases, access
          to credit facilities,and much more.
        </Text>
        <Flex
          gap={{ base: "11px", md: "1rem" }}
          justifyContent="center"
          pt="2rem"
        >
          <Link href="https://www.bizflex.africa/" isExternal target="_blank">
            <Button
              w={[" 153px", "211px"]}
              bgColor="#FF9D16"
              color="white"
              borderRadius="12px"
              boxShadow="md"
              _hover={{ bgGradient: "linear(to-r, #FF9D16, #2463EB)" }}
              _active={{ transform: "scale(0.98)", boxShadow: "sm" }}
              _focus={{ boxShadow: "outline" }}
              px="28px"
              height={{ base: "49px", md: "68px" }}
              fontSize={{ base: "14px", md: "20px" }}
              fontWeight={500}
            >
              Explore Product
            </Button>
          </Link>
          <Link
            target="_blank"
            href=" https://www.bizflex.com.ng/register-step-1"
            isExternal
          >
            <Button
              w={[" 153px", "211px"]}
              bg="transparent"
              border="2px solid #fff"
              color="white"
              borderRadius="12px"
              boxShadow="md"
              px="28px"
              height={{ base: "49px", md: "68px" }}
              fontSize={{ base: "14px", md: "20px" }}
              fontWeight={500}
            >
              Sign Up
            </Button>
          </Link>
        </Flex>
        <Flex
          pt={{ base: "27px", md: "80px" }}
          pb="20px"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text fontSize={{ base: "10px", md: "12px" }}>
            Register Your Business Today!
          </Text>
          <Image w={{ base: "46px", md: "117px" }} src={bizflexLogo2} />
        </Flex>
      </Box>
    </Wrapper>
  );
};
export default SeventhLayer;
